import { render } from "./AttachBoardIcon.vue?vue&type=template&id=5ce94d10"
import script from "./AttachBoardIcon.vue?vue&type=script&lang=js"
export * from "./AttachBoardIcon.vue?vue&type=script&lang=js"
script.render = render

export default script